import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export default [{
  path: "/storeCodeindex/:code",
  component: function component() {
    return import("../../../views/store-code/index.vue");
  },
  name: "storeCodeindex",
  meta: {
    title: "扫码",
    foot: true
  }
}];